import React from 'react';

const useDate = (date: number) => {
  const time = new Date(String(date).length === 10 ? date * 1000 : date)
  return {
    year: time.getFullYear(),
    month: (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1,
    day: time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
  }
}

const DateRangeFormatter = (start: string, end: string) => {
  // 日期解析器（规避时区问题）
  const parseDate = (dateStr: string) => {
    const [datePart] = dateStr.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  // 日期格式化
  const formatDateObj = (date: Date) => ({
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  });

  // 主逻辑
  const generateRangeString = () => {
    const startDate = formatDateObj(parseDate(start));
    const endDate = formatDateObj(parseDate(end));
    if (start == end) {
      return `${startDate.year}年${startDate.month}月${startDate.day}日`;
    }
    if (startDate.year === endDate.year) {
      if (startDate.month === endDate.month) {
        return `${startDate.year}年${startDate.month}月${startDate.day}-${endDate.day}日`;
      }
      return `${startDate.year}年${startDate.month}月${startDate.day}日-${endDate.month}月${endDate.day}日`;
    }
    return `${startDate.year}年${startDate.month}月${startDate.day}日-${endDate.year}年${endDate.month}月${endDate.day}日`;
  };

  return generateRangeString();
};

export { useDate, DateRangeFormatter }